/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IEcommPageNaviViewProps } from './ecomm-page-navi';

/**
 *
 * EcommPageNaviView component
 * @extends {React.PureComponent<IEcommPageNaviViewProps>}
 */
export class EcommPageNaviView extends React.PureComponent<IEcommPageNaviViewProps> {
  public render(): JSX.Element | null {
    const { links, PageNaviContainer } = this.props;

    if (!links) {
      this.props.context.telemetry.error('Navigation content is empty, module will not render.');
      return null;
    }

    return (
      <div className={PageNaviContainer.className}>
        {links && links.map((link, index) =>
          <div key={index}>{link}</div>
        )}
      </div>
    );
  }
}

export default EcommPageNaviView;